import 'react-datepicker/dist/react-datepicker.css';
import '../styles.scss';
import '../GlobalCSSOverrides.css';
import 'react-toastify/dist/ReactToastify.css';
import { AppRoutesWrapper, ErrorBoundaryWrapper } from '@vivli/core/wrapper';
import { CookieWarningComponent } from '@vivli/shared/components';
import { PlatformCoreInitWrapper } from '@vivli/core/infrastructure/wrappers';

export function App() {
    if (!navigator.cookieEnabled) {
        return <CookieWarningComponent />;
    }

    return (
        <PlatformCoreInitWrapper>
            <ErrorBoundaryWrapper>
                <AppRoutesWrapper />
            </ErrorBoundaryWrapper>
        </PlatformCoreInitWrapper>
    );
}

export default App;
